import { alpha, Button, Stack } from "@mui/material";

export const WEARABLE_RANGE_PRESETS = [1, 5, 10, 15, 30] as const;
export type WearableRangeDays = (typeof WEARABLE_RANGE_PRESETS)[number];

function formatRangePresetLabel(preset: WearableRangeDays): string {
  return preset === 1 ? "1 dia" : `${preset} dias`;
}

interface WearableDateRangeChipsProps {
  rangeDays: WearableRangeDays;
  onChange: (days: WearableRangeDays) => void;
  disabled?: boolean;
  tone?: "default" | "onPrimary";
}

export function WearableDateRangeChips({
  rangeDays,
  onChange,
  disabled = false,
  tone = "default",
}: WearableDateRangeChipsProps) {
  const isOnPrimary = tone === "onPrimary";

  return (
    <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
      {WEARABLE_RANGE_PRESETS.map((preset) => {
        const isActive = rangeDays === preset;

        return (
          <Button
            key={preset}
            size="small"
            variant={isOnPrimary ? "text" : isActive ? "contained" : "outlined"}
            color={isOnPrimary ? "inherit" : "primary"}
            disabled={disabled}
            onClick={() => onChange(preset)}
            sx={{
              minWidth: "auto",
              px: 1.25,
              flexShrink: 0,
              fontWeight: isActive ? 700 : 500,
              fontSize: "0.8125rem",
              whiteSpace: "nowrap",
              ...(isOnPrimary && {
                color: "white",
                border: "1px solid",
                borderColor: isActive
                  ? (t) => alpha(t.palette.common.white, 0.85)
                  : (t) => alpha(t.palette.common.white, 0.35),
                bgcolor: isActive
                  ? (t) => alpha(t.palette.common.white, 0.22)
                  : "transparent",
                "&:hover": {
                  bgcolor: isActive
                    ? (t) => alpha(t.palette.common.white, 0.28)
                    : (t) => alpha(t.palette.common.white, 0.1),
                  borderColor: (t) => alpha(t.palette.common.white, 0.55),
                },
                "&.Mui-disabled": {
                  color: (t) => alpha(t.palette.common.white, 0.35),
                  borderColor: (t) => alpha(t.palette.common.white, 0.15),
                },
              }),
            }}
          >
            {formatRangePresetLabel(preset)}
          </Button>
        );
      })}
    </Stack>
  );
}
